import { Prize } from '@/entities/giveaway/types';
import { SortedPrize } from './types';

export const sortPrizesByStartRange = (prizes: Prize[]): SortedPrize[] => {
  return prizes
    .filter(prize => prize.start_range !== 0 || prize.end_range !== 0)
    .map(prize => ({
      ...prize,
      displayOrder: prize.start_range
    }))
    .sort((a, b) => a.displayOrder - b.displayOrder);
};

export const getPrizeAction = (prize: Prize) => {
  if (prize.currency_type === 'nfts' && prize.details_url) {
    return {
      type: 'nft' as const,
      url: prize.details_url,
      handler: () => {
        window?.Telegram?.WebApp?.openTelegramLink(prize.details_url);
      }
    };
  }

  return {
    type: 'stars' as const,
    handler: () => {
    }
  };
}; 